module.exports = {
    values: {
        'Pressure Tests Specification': 'Especificação de Testes de Pressão',
        'Copy': 'Copiar',
        'Error loading Pressure Tests Specification': 'Erro ao carregar a Especificação de Testes de Pressão',
        'Configure Pressure Tests': 'Configurar Testes de Pressão',
        'Specification successfully copied to the clipboard.': 'Especificação copiada para a área de transferência.'
    }
}
